import $ from 'jquery';

$(function () {
	function setLineStyles() {
		let windowWidth = window.innerWidth;
		let lineWidth = windowWidth -15;
		if (windowWidth < 992) {
			$('.header-line').css({width: lineWidth, top: 40})
		}
		else if (windowWidth >= 1200) {
			$('.sushi-block').each(function () {
				let $image = $('.sushi-image', this);
				let $text = $('.sushi-text', this);
				let imageTop = $image.offset().top;
				let textTop = $text.offset().top;
				let lineOffset = (textTop - imageTop) / 2;


				$('.header-line', this).css({top: -lineOffset})
			});
		}
	}

	function setBackground () {
		let $bg = $('.canvas-limit-background');

		if ($bg.length > 0) {
			let left = $bg.parent().offset().left;
			let parentWidth = $bg.parent().width();
			let windowWidth = window.innerWidth / 2;
			let right = windowWidth - (left + parentWidth);
			if (window.innerWidth >= 992) {
				$bg.css({left: -left, right: -right})
			}
			else if (window.innerWidth < 992) {
				$bg.css({left: 0, right: 0});
			}
		}
	}

	setLineStyles();
	setBackground ();

	$(window).on('resize', function () {
		setLineStyles();
		setBackground();
	});
});
